import * as React from 'react';



export default class orgAccess extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 16 16" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g fill="none" fillRule="evenodd" stroke="#666" opacity=".8">
                <path d="M10.652 13.867H.722v-2.145a4.966 4.966 0 0 1 9.93 0v2.145zM7.95 3.066a2.262 2.262 0 1 1-4.524 0 2.262 2.262 0 0 1 4.523 0z"/>
                <path d="M7.105 6.962a4.512 4.512 0 0 1 6.296 4.145v1.949h-2.456M7.436 1.789a2.056 2.056 0 1 1 .061 2.966"/>
            </g>
      </svg>
    )
  }
}
